import React from 'react';
import { IconProps } from './Icons';

export const WindowsIcon: React.FC<IconProps> = ({ stroke }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <g clipPath="url(#clip0_3056_604)">
      <path
        d="M2.5 4.56583L8.6475 3.71917V9.65833H2.5V4.56667V4.56583ZM2.5 15.4342L8.6475 16.2817V10.415H2.5V15.4342ZM9.32333 16.3717L17.5 17.5V10.415H9.32333V16.3717ZM9.32333 3.62833V9.65833H17.5V2.5L9.32333 3.62833Z"
        fill={stroke ?? 'white'}
      />
    </g>
    <defs>
      <clipPath id="clip0_3056_604">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const MacOSIcon: React.FC<IconProps> = ({ stroke }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <g clipPath="url(#clip0_3056_610)">
      <path
        d="M9.68672 6.0185C8.95672 6.0185 7.82672 5.1885 6.63672 5.2185C5.06672 5.2385 3.62672 6.1285 2.81672 7.5385C1.18672 10.3685 2.39672 14.5485 3.98672 16.8485C4.76672 17.9685 5.68672 19.2285 6.90672 19.1885C8.07672 19.1385 8.51672 18.4285 9.93672 18.4285C11.3467 18.4285 11.7467 19.1885 12.9867 19.1585C14.2467 19.1385 15.0467 18.0185 15.8167 16.8885C16.7067 15.5885 17.0767 14.3285 17.0967 14.2585C17.0667 14.2485 14.6467 13.3185 14.6167 10.5185C14.5967 8.1785 16.5267 7.0585 16.6167 7.0085C15.5167 5.3985 13.8267 5.2185 13.2367 5.1785C11.6967 5.0585 10.4067 6.0185 9.68672 6.0185ZM12.2867 3.6585C12.9367 2.8785 13.3667 1.7885 13.2467 0.708496C12.3167 0.748496 11.1967 1.3285 10.5267 2.1085C9.92672 2.7985 9.40672 3.9085 9.54672 4.9685C10.5767 5.0485 11.6367 4.4385 12.2867 3.6585Z"
        fill={stroke ?? 'white'}
      />
    </g>
    <defs>
      <clipPath id="clip0_3056_610">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
